module.exports = __webpack_public_path__ + "static/media/planogram-icon.fde0bb69.svg";